import LogRocket from 'logrocket';
import moment from "moment";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import NotificationContainer from "./components/common/react-notifications/NotificationContainer";
import "./helpers/Firebase";
import { auth, firestore } from "./helpers/Firebase";
import { accessTypes, createNotification, getDirection } from "./helpers/Utils";
import AppLocale from "./lang";
import {
  getAdvServices,
  getAppointmentsList,
  getBanners,
  getList,
  getModifiers,
  getServices,
  getUpSeLlingList,
  getVariations,
  getCustomersVouchers,
  getWasherList,
  loginUserSuccess,
  logoutUser,
  getVouchers,
  getPromocodes
} from "./redux/actions";
import main from "./views";
import app from "./views/app";
import error from "./views/error";
import ProcessPayment from './views/handlePayment';
// import Payment from './views/payment.js';
import user from "./views/user";
import { ORDER_COLLECTION } from './config/env';
import soundFile from './helpers/neworder.mp3';

if (window.location.hostname !== 'localhost') {
  LogRocket.init('5eafnv/chill');
}

const AuthRoute = ({ component: Component, authUser, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        authUser?.uid ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/user/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
};

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      deactivatedProvider: false
    }
    // Store unsubscribe functions for all Firestore listeners
    this.unsubscribes = {
      serviceProvider: null,
      bookings: null,
      bookings2: null,
      walletLog: null,
      dbCollections: []
    }
    // Store snapshot data for combining
    this.snapshotData = {
      ref1: [],
      ref2: [],
      ref3: []   // order recovery: staff-only `reassigning == true` bookings (rejected/canceled, so outside ref1)
    }
    // Track previous booking IDs to detect new orders
    this.previousBookingIds = new Set()
    // Track if initial load is complete (to avoid playing sounds on initial load)
    this.isInitialLoad = true
    // Audio element for sound notifications
    this.audioRef = null
    // Track if audio is enabled (after user interaction)
    this.audioEnabled = false
    // Track if sound is currently playing for pending quickWash orders
    this.soundIntervalId = null
    // Sound interval duration (play every 5 seconds)
    this.soundIntervalDuration = 5000
  }

  componentWillMount() {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
    } else {
      document.body.classList.add("ltr");
      document.body.classList.remove("rtl");
    }

    // Enable audio on first user interaction (click anywhere)
    const enableAudio = () => {
      if (!this.audioEnabled && !this.audioRef) {
        try {
          this.audioRef = new Audio(soundFile)
          this.audioRef.volume = 0.5
          // Try to play and immediately pause to enable audio
          this.audioRef.play().then(() => {
            this.audioRef.pause()
            this.audioRef.currentTime = 0
            this.audioEnabled = true
          }).catch(() => {
            // If it fails, we'll show notifications instead
            this.audioEnabled = false
          })
        } catch (error) {
          this.audioEnabled = false
        }
      }
      // Remove listeners after first interaction
      document.removeEventListener('click', enableAudio)
      document.removeEventListener('touchstart', enableAudio)
    }

    // Listen for first user interaction
    document.addEventListener('click', enableAudio, { once: true })
    document.addEventListener('touchstart', enableAudio, { once: true })

    auth().onAuthStateChanged(user => {
      let _this = this
      let currentDate = moment().subtract(14, 'days').valueOf()
      if (user) {
        this.setState({ loading: true }, () => {
          user.getIdTokenResult(true).then(async result => {
            let { role } = result.claims

            if (!['superAdmin', 'finance', 'customerService', 'marketing', 'admin'].includes(role)) {
              await auth().signOut()
              localStorage.removeItem('user_id');
              localStorage.removeItem('role');
              this.props.loginUserSuccess({})
              this.setState({ loading: false })
              return createNotification("error", 'This user is not authorized to login to dashboard', "Error")
            }

            let post = {
              email: user.email,
              uid: user.uid,
              displayName: user.displayName,
              accessType: role,
              phoneNumber: user.phoneNumber
            }
            LogRocket.identify(user.uid, {
              name: user.displayName,
              email: user.email
            });

            if (["admin"].includes(role)) {
              this.unsubscribes.serviceProvider = firestore().collection('service_provider').doc(user.uid).onSnapshot(async function (snap) {
                let providerData = snap.data()
                if ((providerData.expiryDate && moment().isAfter(moment(providerData.expiryDate))) || providerData?.deActivated) {
                  // if ((providerData.expiryDate && moment().isAfter(moment(providerData.expiryDate))) || providerData?.deActivated || !providerData?.active) {
                  await auth().signOut()
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('role');
                  _this.props.loginUserSuccess({})
                  _this.setState({ loading: false, deactivatedProvider: true })
                  return
                }
              })
              let snap = await firestore().collection('service_provider').doc(user.uid).get()
              let providerData = snap.data()
              if ((providerData.expiryDate && moment().isAfter(moment(providerData.expiryDate))) || providerData?.deActivated) {
                // if ((providerData.expiryDate && moment().isAfter(moment(providerData.expiryDate))) || providerData?.deActivated || !providerData?.active) {
                await auth().signOut()
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                _this.props.loginUserSuccess({})
                _this.setState({ loading: false, deactivatedProvider: true })
                return
              }
            }

            let ref = firestore().collection(ORDER_COLLECTION)
            let ref2 = null
            let ref3 = null
            if (!accessTypes.includes(role)) {
              ref = ref.where("sp_id", "==", user.uid)
              ref2 = firestore().collection(ORDER_COLLECTION).where("serviceProviders", 'array-contains', user.uid)
            } else {
              // Order recovery: bookings a provider rejected/cancelled that the server is
              // re-homing. They are excluded from ref1 by status, so staff get them here.
              ref3 = firestore().collection(ORDER_COLLECTION).where('reassigning', '==', true)
            }
            // Combined query for all relevant booking statuses with date filter
            const relevantStatuses = ['new', 'pending', 'accepted', 'active', 'completed', 'notRated']
            // For ref2, only query new and pending statuses
            const ref2Statuses = ['new', 'pending']
            
            // Helper function to play sound notification
            const playQuickWashSound = () => {
              try {
                // Create audio element if it doesn't exist
                if (!_this.audioRef) {
                  _this.audioRef = new Audio(soundFile)
                  _this.audioRef.volume = 0.5 // Set volume to 50%
                }
                // Reset audio to beginning and play
                _this.audioRef.currentTime = 0
                _this.audioRef.play().catch(error => {
                  // If audio fails, show visual notification instead
                  createNotification("info", "New Quick Wash / Recovery Order Received!", "New Order")
                })
              } catch (error) {
                // If audio initialization fails, show visual notification
                createNotification("info", "New Quick Wash / Recovery Order Received!", "New Order")
              }
            }

            // Helper function to start continuous sound if there are pending orders
            const startSoundIfNeeded = () => {
              // Don't start if already playing
              if (_this.soundIntervalId) {
                return
              }

              // Play immediately
              playQuickWashSound()

              // Set up interval to play sound repeatedly
              _this.soundIntervalId = setInterval(() => {
                playQuickWashSound()
              }, _this.soundIntervalDuration)
            }

            // Helper function to stop sound
            const stopSound = () => {
              if (_this.soundIntervalId) {
                clearInterval(_this.soundIntervalId)
                _this.soundIntervalId = null
              }
            }

            // Helper function to combine and process snapshots
            const combineAndProcessSnapshots = () => {
              // Combine both snapshots, deduplicating by document ID
              const combinedMap = new Map()
              
              // Add data from ref1
              _this.snapshotData.ref1.forEach(item => {
                combinedMap.set(item.id, item)
              })
              
              // Add data from ref2 (will overwrite duplicates with same ID)
              if (_this.snapshotData.ref2 && Array.isArray(_this.snapshotData.ref2)) {
                _this.snapshotData.ref2.forEach(item => {
                  combinedMap.set(item.id, item)
                })
              }
              if (_this.snapshotData.ref3 && Array.isArray(_this.snapshotData.ref3)) {
                _this.snapshotData.ref3.forEach(item => {
                  combinedMap.set(item.id, item)
                })
              }
              
              // Convert map to array
              let data = Array.from(combinedMap.values())

              // Find all pending quickWash and recovery orders (status 'new' or 'pending')
              const pendingQuickWashOrders = data.filter(booking => 
                (booking.service_type === 'quickWash' || (booking.service_type === 'recovery' && booking.recoveryInfo?.scheduleType === 'sos')) && 
                (booking.status === 'new' || booking.status === 'pending')
              )

              // Only check after initial load is complete
              if (!_this.isInitialLoad) {
                // If there are pending orders, start/continue sound
                if (pendingQuickWashOrders.length > 0) {
                  startSoundIfNeeded()
                } else {
                  // If no pending orders, stop sound
                  stopSound()
                }
              } else {
                // Mark initial load as complete after first snapshot
                _this.isInitialLoad = false
              }

              // Update previous booking IDs
              const currentBookingIds = new Set(data.map(booking => booking.id))
              _this.previousBookingIds = currentBookingIds

              // Calculate delayed status for each booking
              data = data.reduce((val, currentVal) => {
                let now = moment()
                let start = moment(currentVal?.bookingDate)
                let diffStart = start.diff(now, 'minutes')

                if (diffStart < 20 && currentVal?.status === 'accepted' && currentVal?.type !== 'offlineBooking') {
                  currentVal.delayed = 'delayedActive'
                } else if (diffStart < -60 && currentVal?.status === 'active' && currentVal?.type !== 'offlineBooking') {
                  currentVal.delayed = 'delayedCompleted'
                }

                val.push(currentVal)
                return val
              }, [])

              _this.props.getAppointmentsList(data || [])
            }

            // Listener for ref (sp_id query)
            this.unsubscribes.bookings = ref
              .where("status", 'in', relevantStatuses)
              .where('bookingDate', '>=', currentDate)
              .onSnapshot(function (querySnapshot) {
                // Map documents to data objects
                _this.snapshotData.ref1 = querySnapshot.docs.map(rec => ({
                  ...rec.data(),
                  id: rec.id,
                  key: rec.id
                }))
                
                combineAndProcessSnapshots()
              })

            // Listener for ref2 (serviceProviders array-contains query) - only for non-accessTypes users
            if (ref2) {
              this.unsubscribes.bookings2 = ref2
                .where("status", 'in', ref2Statuses)
                .where('bookingDate', '>=', currentDate)
                .onSnapshot(function (querySnapshot) {
                  // Map documents to data objects
                  _this.snapshotData.ref2 = querySnapshot.docs.map(rec => ({
                    ...rec.data(),
                    id: rec.id,
                    key: rec.id
                  }))
                  
                  combineAndProcessSnapshots()
                })
            } else {
              // Initialize ref2 data as empty array if ref2 is not used (for accessTypes users)
              _this.snapshotData.ref2 = []
            }

            // Listener for ref3 (order recovery, staff only)
            if (ref3) {
              this.unsubscribes.bookings3 = ref3.onSnapshot(function (querySnapshot) {
                _this.snapshotData.ref3 = querySnapshot.docs.map(rec => ({
                  ...rec.data(),
                  id: rec.id,
                  key: rec.id
                }))
                combineAndProcessSnapshots()
              }, function (error) {
                console.log('reassigning listener error', error)
                _this.snapshotData.ref3 = []
              })
            } else {
              _this.snapshotData.ref3 = []
            }


            this.unsubscribes.walletLog = firestore().collectionGroup('walletLog').where('type', '==', 'voucher').onSnapshot(async function (querySnapshot) {
              let data = querySnapshot?.docs?.map(rec => {
                return ({ ...rec.data(), id: rec.id, key: rec.id })
              });
              _this.props.getCustomersVouchers(data)
            });

            this.props.loginUserSuccess(post)

            let db = [
              { ref: 'service_provider', func: 'getList' },
              { ref: 'washers', func: 'getWasherList' },
              { ref: 'up_selling', func: 'getUpSeLlingList' },
              { ref: 'services', func: 'getServices' },
              { ref: 'modifiers', func: 'getModifiers' },
              { ref: 'advServices', func: 'getAdvServices' },
              { ref: 'tintingVariations', func: 'getVariations' },
              { ref: 'banners', func: 'getBanners' },
              { ref: 'vouchers', func: 'getVouchers' },
              { ref: 'offers', func: 'getPromocodes' }
            ];

            db.forEach(itm => {
              let ref2 = firestore().collection(itm.ref)

              if (itm.ref === "service_provider" && !accessTypes.includes(role)) {
                ref2 = ref2.where("key", "==", user.uid)

              } else if (!accessTypes.includes(role) && itm.ref !== "services" && itm.ref !== "advServices" && itm.ref !== "modifiers") {
                ref2 = ref2.where("sp_id", "==", user.uid)
              }

              const unsubscribe = ref2.onSnapshot(snap => {
                let allData = {}

                snap.forEach(rec => {
                  let data = rec.data()

                  if (!data.deActivated) {
                    allData[rec.id] = { ...data, key: rec.id, value: data.name, label: data.name }
                    return false
                  }
                })
                this.props[itm.func](allData)
                this.setState({ loading: false })

              })

              // Store the unsubscribe function
              this.unsubscribes.dbCollections.push(unsubscribe)
            })
            // } else {
            //   localStorage.removeItem('user_id');
            //   localStorage.removeItem('accessType');
            //   this.props.loginUserSuccess({})
            //   this.setState({ loading: false })
            // }
          })
        })

      } else {
        // Unsubscribe from all listeners when user logs out
        if (this.unsubscribes.serviceProvider) {
          this.unsubscribes.serviceProvider()
        }
        if (this.unsubscribes.bookings) {
          this.unsubscribes.bookings()
        }
        if (this.unsubscribes.bookings2) {
          this.unsubscribes.bookings2()
        }
        if (this.unsubscribes.bookings3) {
          this.unsubscribes.bookings3()
        }
        if (this.unsubscribes.walletLog) {
          this.unsubscribes.walletLog()
        }
        // Reset snapshot data
        this.snapshotData = { ref1: [], ref2: [], ref3: [] }
        // Unsubscribe from all database collection listeners
        this.unsubscribes.dbCollections.forEach(unsubscribe => {
          if (unsubscribe) {
            unsubscribe()
          }
        })
        // Reset unsubscribe array
        this.unsubscribes.dbCollections = []
        // Stop sound interval
        if (this.soundIntervalId) {
          clearInterval(this.soundIntervalId)
          this.soundIntervalId = null
        }

        // Reset tracking state
        this.previousBookingIds = new Set()
        this.isInitialLoad = true
        this.audioEnabled = false
        this.snapshotData = { ref1: [], ref2: [] }
        // Clean up audio reference
        if (this.audioRef) {
          this.audioRef.pause()
          this.audioRef = null
        }

        localStorage.removeItem('user_id');
        localStorage.removeItem('accessType');
        this.props.loginUserSuccess({})
        this.setState({ loading: false })
      }
    })
  }

  componentWillUnmount() {
    // Stop sound interval
    if (this.soundIntervalId) {
      clearInterval(this.soundIntervalId)
      this.soundIntervalId = null
    }

    // Unsubscribe from all Firestore listeners to prevent memory leaks
    if (this.unsubscribes.serviceProvider) {
      this.unsubscribes.serviceProvider()
    }
    if (this.unsubscribes.bookings) {
      this.unsubscribes.bookings()
    }
    if (this.unsubscribes.bookings2) {
      this.unsubscribes.bookings2()
    }
    if (this.unsubscribes.bookings3) {
      this.unsubscribes.bookings3()
    }
    if (this.unsubscribes.walletLog) {
      this.unsubscribes.walletLog()
    }
    // Unsubscribe from all database collection listeners
    this.unsubscribes.dbCollections.forEach(unsubscribe => {
      if (unsubscribe) {
        unsubscribe()
      }
    })

    // Clean up audio reference
    if (this.audioRef) {
      this.audioRef.pause()
      this.audioRef = null
    }
  }

  render() {
    const { locale, loginUser } = this.props;
    let { loading, deactivatedProvider } = this.state
    const currentAppLocale = AppLocale[locale];

    if (loading) {
      return <div className="loading" />
    }
    return (
      <div className="h-100">
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <React.Fragment>
            <Modal backdrop="static" isOpen={deactivatedProvider}>
              <ModalHeader >Dear Service Provider</ModalHeader>
              <ModalBody>
                <Label className="mb-2">
                  Be informed that your account has been deactivated or your subscription has expired. Please contact us to reactivate or renew your subscription.
                </Label>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => this.setState({ deactivatedProvider: false })}>Dismiss</Button>
              </ModalFooter>

            </Modal>

            <NotificationContainer />
            {/* {isMultiColorActive && <ColorSwitcher />} */}
            <Router>
              <Switch>
                {/* <Route path="/pay" component={Payment} /> */}
                <Route path='/processpayment' component={ProcessPayment} />
                <AuthRoute path="/app" authUser={loginUser} component={app} />
                {
                  loginUser && loginUser.uid && <Redirect to='/app' />
                }
                <Route path="/user" component={user} />
                <Route path="/error" exact component={error} />
                <Route path="/" exact component={main} />
                <Redirect to="/error" />
              </Switch>
            </Router>
          </React.Fragment>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, settings }) => {
  const { user } = authUser;
  const { locale } = settings;
  return {
    loginUser: user, locale,
  };
};
const mapActionsToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser()),
  loginUserSuccess: (user) => dispatch(loginUserSuccess(user)),
  getList: (user) => dispatch(getList(user)),
  getWasherList: (user) => dispatch(getWasherList(user)),
  getAppointmentsList: (bookings) => dispatch(getAppointmentsList(bookings)),
  getUpSeLlingList: (user) => dispatch(getUpSeLlingList(user)),
  getServices: (user) => dispatch(getServices(user)),
  getModifiers: (user) => dispatch(getModifiers(user)),
  getAdvServices: (user) => dispatch(getAdvServices(user)),
  getVariations: (user) => dispatch(getVariations(user)),
  getBanners: (user) => dispatch(getBanners(user)),
  getCustomersVouchers: (user) => dispatch(getCustomersVouchers(user)),
  getVouchers: (user) => dispatch(getVouchers(user)),
  getPromocodes: (user) => dispatch(getPromocodes(user))
});

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);
